// Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  
  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="bg-gradient-to-r from-red-500 to-blue-500 text-white">
      <div className="container mx-auto px-6 py-8">
        {/* Top Section: Logo and Navigation Links */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0 text-center">
            <h2 className="text-3xl font-bold">SomeOne4u</h2>
            <p className="text-sm mt-1">Find your perfect match.</p>
          </div>
          <div className="flex space-x-6">
            <Link to="/aboutus" className="transition-colors duration-300 hover:underline hover:text-gray-200" onClick={scrollToTop}>
              About Us
            </Link>
            <Link to="/contactus" className="transition-colors duration-300 hover:underline hover:text-gray-200" onClick={scrollToTop}>
              Contact
            </Link>
            <Link to="/privacypolicy" className="transition-colors duration-300 hover:underline hover:text-gray-200" onClick={scrollToTop}>
              Privacy Policy
            </Link>
            <Link to="/terms" className="transition-colors duration-300 hover:underline hover:text-gray-200" onClick={scrollToTop}> 
              Terms of Use
            </Link>
          </div>
        </div>
        
        <hr className="my-6 border-white opacity-50" />
        
        {/* Bottom Section: Social Links and Copyright */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex space-x-4">
            <Link 
              to="https://instagram.com/yourprofile" 
              target="_blank" 
              rel="noopener noreferrer"
              className="transition-colors duration-300 hover:text-gray-200"
            >
              <i className="fab fa-instagram text-2xl"></i>
            </Link>
            <Link 
              to="https://youtube.com/yourchannel" 
              target="_blank" 
              rel="noopener noreferrer"
              className="transition-colors duration-300 hover:text-gray-200"
            >
              <i className="fab fa-youtube text-2xl"></i>
            </Link>
            {/* Add more social links as needed */}
          </div>
          <p className="mt-4 md:mt-0 text-sm">
            &copy; {new Date().getFullYear()} SomeOne4u. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
